module.exports = __webpack_public_path__ + "img/8.f034992f.png";